import { Col, Row } from "antd";
import classNames from "classnames";
import { get, isEmpty, range } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import Budget from "shared/assets/images/budget.png";
import Button from "shared/components/Button";
import Card from "shared/components/Card";
import Header from "shared/components/Header";
import Input from "shared/components/Input";
import Switch from "shared/components/Input/Switch";
import Slider from "shared/components/Slider";
import { NAME_SPACES } from "shared/locales/constants";
import spaIcon from "../../../Comparison/Miltis/Assets/icons/spa.png";

const getDefaultLabel = (value, translate) => {
  return (
    translate?.TEMPLATES?.FILTERS?.HEADER?.LEVELS?.LABELS?.[String(value)] ||
    `Niveau ${value}`
  );
};

const View = ({
  project,
  next,
  onBack,
  nextLoading,
  data,
  needsLevels = 5,
  labels = {},
}) => {
  const [needs, setNeeds] = useState(get(project, "fields.needs", {}));
  const [fields, setFields] = useState({
    ...project.fields,
    budget: {
      ...get(project.fields, "budget", { min: 0, max: 1000 }),
    },
  });
  const [alternativeMedicineEnabled, setMedecinDouceEnabled] = useState(
    get(needs, "alternativeMedicine", false),
  );
  const levels = range(1, needsLevels + 1);
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  const DETAIL = t("DETAIL", { returnObjects: true });
  const [budgetError, setBudgetError] = useState(false);
  const switches = data.filter(({ order }) => order === 100);

  return (
    <>
      <Header
        key={"header"}
        title={DETAIL.TEMPLATES.CONTACT.TITLE}
        actions={[]}
      />
      <div className="template-product-filters--container">
        <div className="template-product-filters--wrapper">
          <Card
            title={DETAIL.TEMPLATES.FILTERS.HEADER.TITLE}
            subtitle={DETAIL.TEMPLATES.FILTERS.HEADER.SUBTITLE}
          >
            <div className="levels--container">
              <div className="levels--wrapper">
                <div />
                <div className="levels--wrapper--levels">
                  {levels.map((element) => (
                    <div key={element} className="label">
                      <div className="popover-wrapper">
                        {/* <Popover
                        text={DETAIL.TEMPLATES.FILTERS.HEADER.LEVELS.POPOVER[element]}
                        /> */}
                        {labels[String(element)] ||
                          getDefaultLabel(element, DETAIL)}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="levels-coverage--container">
                {data
                  ?.filter(({ order }) => order !== 100)
                  .map(({ icon, label, id, value }) => (
                    <div key={id} className="levels-coverage--wrapper">
                      <div className="coverage-trailing--wrapper">
                        <img className="img" src={icon} alt={label} />
                        <span className="label">{label}</span>
                      </div>
                      <div className="custom-slider--wrapper flex-end">
                        <Slider
                          type="dot"
                          items={levels}
                          name={"grp" + label}
                          value={
                            (get(needs, value, 1) > needsLevels
                              ? needsLevels
                              : get(needs, value, 1)) || 1
                          }
                          onChange={(item) =>
                            setNeeds((prev) => ({
                              ...prev,
                              [value]: item,
                            }))
                          }
                        />
                      </div>
                    </div>
                  ))}
                {switches?.map(({ icon, label, id, value }) => (
                  <div key={id} className="levels-coverage--wrapper switch">
                    <div className="coverage-trailing--wrapper">
                      <img className="img" src={icon} alt={label} />
                      <span className="label">{label}</span>
                    </div>
                    <div className="custom-slider--wrapper">
                      <Switch
                        className="button__switch"
                        checkedChildren={DETAIL.YES}
                        unCheckedChildren={DETAIL.NO}
                        defaultChecked={get(needs, value, 1) === 2}
                        onChange={(item) =>
                          setNeeds((prev) => ({
                            ...prev,
                            [value]: item ? 2 : 1,
                          }))
                        }
                      />
                    </div>
                  </div>
                ))}
                <div className="levels-coverage--wrapper switch">
                  <div className="coverage-trailing--wrapper">
                    <img className="img" src={spaIcon} alt="Médecine douce" />
                    <span className="label">
                      {DETAIL.TEMPLATES.FILTERS.MEDECIN_DOUCE?.TITLE ||
                        "Avez-vous des besoins en Médecine douces ?"}
                    </span>
                  </div>
                  <div className="custom-slider--wrapper">
                    <Switch
                      className="button__switch"
                      checkedChildren={DETAIL.YES}
                      unCheckedChildren={DETAIL.NO}
                      checked={alternativeMedicineEnabled}
                      onChange={(checked) => {
                        setMedecinDouceEnabled(checked);
                        setNeeds((prev) => ({
                          ...prev,
                          alternativeMedicine: checked,
                        }));
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Card>
          <div className="budget--container">
            <Row align="middle" gutter={[16, 16]}>
              <Col lg={8} xs={24}>
                <div className="trailing--wrapper">
                  <img className="img" src={Budget} alt="Budget client" />
                  <div className="text">
                    <span className="main">
                      {DETAIL.TEMPLATES.FILTERS.BUDGET.TITLE}
                    </span>
                    <span className="second">
                      {DETAIL.TEMPLATES.FILTERS.BUDGET.SUBTITLE}
                    </span>
                  </div>
                </div>
              </Col>
              <Col lg={16} xs={24}>
                <div className="budget-action--wrapper">
                  <Row gutter={[24, 24]}>
                    <Col lg={24} xs={24}>
                      <div className="custom-slider--wrapper">
                        <Slider
                          type="line"
                          tooltip={{
                            open: true,
                            formatter: (value) => `${value} €`,
                          }}
                          range
                          min={0}
                          max={1000}
                          value={[
                            get(fields, "budget.min"),
                            get(fields, "budget.max"),
                          ]}
                          onChange={([min, max]) => {
                            setBudgetError(false);
                            setFields((fields) => ({
                              ...fields,
                              budget: {
                                min,
                                max,
                              },
                            }));
                          }}
                        />
                      </div>
                    </Col>
                    <Col lg={24} xs={24}>
                      <div className="custom-input--wrapper">
                        <Row align="bottom" gutter={[7, 7]}>
                          <Col lg={11} xs={24}>
                            <Input
                              type="number"
                              suffix="€"
                              value={get(fields, "budget.min")}
                              label={DETAIL.TEMPLATES.FILTERS.BUDGET.MIN}
                              min={0}
                              max={get(fields, "budget.max")}
                              onChange={({ target: { value } }) => {
                                const numValue = Number(value);
                                const currentMax = get(
                                  fields,
                                  "budget.max",
                                  1000,
                                );
                                if (numValue <= 1000) {
                                  if (numValue <= currentMax) {
                                    setBudgetError(false);
                                    setFields((fields) => ({
                                      ...fields,
                                      budget: {
                                        ...fields.budget,
                                        min: numValue,
                                      },
                                    }));
                                  } else {
                                    setBudgetError(true);
                                  }
                                }
                              }}
                              onBlur={({ target: { value } }) => {
                                const numValue = Number(value);
                                if (numValue > get(fields, "budget.max")) {
                                  setBudgetError(true);
                                } else {
                                  setBudgetError(false);
                                }
                              }}
                              touched
                              errors={budgetError}
                            />
                          </Col>
                          <Col lg={2} xs={24}>
                            <div className="divider-input" />
                          </Col>
                          <Col lg={11} xs={24}>
                            <Input
                              type="number"
                              suffix="€"
                              value={get(fields, "budget.max")}
                              label={DETAIL.TEMPLATES.FILTERS.BUDGET.MAX}
                              max={1000}
                              min={get(fields, "budget.min")}
                              onChange={({ target: { value } }) => {
                                const numValue = Number(value);
                                const currentMin = get(fields, "budget.min", 0);
                                if (numValue <= 1000) {
                                  if (numValue >= currentMin) {
                                    setBudgetError(false);
                                    setFields((fields) => ({
                                      ...fields,
                                      budget: {
                                        ...fields.budget,
                                        max: numValue,
                                      },
                                    }));
                                  } else {
                                    setBudgetError(true);
                                  }
                                }
                              }}
                              onBlur={({ target: { value } }) => {
                                const numValue = Number(value);
                                if (numValue < get(fields, "budget.min")) {
                                  setBudgetError(true);
                                } else {
                                  setBudgetError(false);
                                }
                              }}
                              touched
                              errors={budgetError}
                            />
                          </Col>
                          <span
                            className={classNames("input--errors", {
                              hidden: !budgetError,
                            })}
                          >
                            {DETAIL.TEMPLATES.FILTERS.BUDGET.ERROR}
                          </span>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
          <div className="d-flex justify--between">
            <Button onClick={onBack} type="secondary--link">
              <MdArrowBackIos size={16} />
              {DETAIL.TEMPLATES.FILTERS.BUTTON.TEXT.PREVIOUS}
            </Button>

            <Button
              onClick={() =>
                next({
                  ...fields,
                  needs: {
                    ...needs,
                    alternativeMedicine: alternativeMedicineEnabled,
                  },
                })
              }
              type="primary"
              loading={nextLoading}
              disabled={
                isEmpty(fields) ||
                get(fields, "budget.min") > get(fields, "budget.max") ||
                project?.expired
              }
            >
              {DETAIL.TEMPLATES.FILTERS.BUTTON.TEXT.SHOW_PRODUCT_LIST}
              <MdArrowForwardIos size={16} />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default View;
